export const CustomEvents = Object.freeze({
    LOGIN: 'login-event',
    LOGOUT: 'logout-event',
});
